import {
    Button,
    Container,
    Grid,
    Group,
    Stack,
    Text
} from '@mantine/core';
import {Dashlet} from "../components/Dashlet";

import {useDashboard} from "../hooks/useDashboard.tsx";
import {DashletType} from "../types.ts";
import {useNavigate} from "react-router-dom";
import {AiOutlineAppstore} from "react-icons/ai";
import {useUserAccount} from "../../../hooks/useUserAccount";
import {BillingSetupCard} from "../../billing-management/customers/components/BillingSetupCard";


export const IndexPage = () => {

    const navigate = useNavigate()

    const {applications} = useDashboard()
    const {userAccount} = useUserAccount()

    return (
        <Container id={'dashboard-container'}>
            <Stack gap={'xl'}>

                {userAccount && !userAccount.customerId && (
                    <BillingSetupCard variant="banner" />
                )}

                <Grid p={'md'}>
                    {applications.map((item: DashletType, index: number) => {
                        return (
                            <Grid.Col key={index} span={{
                                xl: 4,
                                lg: 4,
                                md: 6,
                                sm: 12,
                                xs: 12,
                            }}>
                                <Dashlet item={item}/>
                            </Grid.Col>
                        );
                    })}
                </Grid>

                <Group justify={'center'} my={'xl'}>

                    <Button
                        variant={'subtle'}
                        leftSection={<AiOutlineAppstore/>}
                        onClick={() => {
                            navigate('/applications')
                        }}
                    >
                        <Text>See All Available Applications</Text>
                    </Button>

                </Group>
            </Stack>
        </Container>
    );
};


